var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabletkeepStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.744 57.251c0-.461-.291-.835-.649-.835h-.784V42.01a8.342 8.342 0 00-8.342-8.342H70.862v-.637a.835.835 0 00-.835-.835h-8.692a.835.835 0 00-.835.835v.637h-3.902a8.343 8.343 0 00-8.343 8.342v117.452a8.342 8.342 0 008.343 8.342h85.37a8.342 8.342 0 008.342-8.342V92.168h.784c.359 0 .649-.374.649-.835V75.127c0-.461-.258-.451-.261-.835-.004-.461.261-.374.261-.835V57.251zM100 161.626a3.468 3.468 0 110-6.937 3.468 3.468 0 010 6.937zm44.593-14.952c0 .982-.796 1.778-1.778 1.778h-85.63a1.778 1.778 0 01-1.778-1.778V42.726c0-.982.796-1.778 1.778-1.778h85.629c.982 0 1.778.796 1.778 1.778v103.948z",
    fill: "#690048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletkeepStyle);
export default __webpack_public_path__ + "static/media/tablet.keepStyle.4e2eafd21549c4d8bca28e19f4e4c3b7.svg";
export { ForwardRef as ReactComponent };